import {
  IBlocSyncInteractor,
  RemoteValidationError,
  SyncInteractor
} from "@kernel/frontend-react-app";

export interface RemoteValidationErrorPorps {
  err: RemoteValidationError;
}

export class RemoteValidationErrorInteractor
  extends SyncInteractor<RemoteValidationErrorPorps, string>
  implements IBlocSyncInteractor<RemoteValidationErrorPorps, string>
{
  public execute({ err }: RemoteValidationErrorPorps): string {
    return err.reason
      ? Array.isArray(err.reason)
        ? err.reason.join(", ")
        : err.reason
      : "";
  }

  public static create() {
    return new RemoteValidationErrorInteractor();
  }
}
